<template>
    <section class="dispatchOrder-table" v-loading="loading">
        <div class="dispatch-table-header">
            <el-button
                type="text"
                class="dispatch-refresh"
                icon="el-icon-refresh"
                @click="refresh"
            >
                刷新
            </el-button>
        </div>
        <table-box
            ref="tablePage"
            :columns="config.table.columns"
            :height="config.table.height"
            :selection="config.table.selection"
            :rows="tableData"
            :actions="config.table.action"
            @onSelectionChange="onSelectionChange"
            @action-click="actionClick"
        >
        </table-box>

        <!-- 电子围栏校验提示和备注 -->
            <dispatch-handle-reason
                v-if="isShowHandleReasonDialog"
                ref="dispatchHandleReason"
                :isShowHandleReasonDialog.sync="isShowHandleReasonDialog"
                :handleType="handleType"
                :dispatchNo="dispatchNo"
                :componentsData="componentsData"
                :needTooltipData="needTooltipData"
                @handleSuccess="handleSuccess"
                @closeFenceDialog="closeFenceDialog"
            ></dispatch-handle-reason>
        <!-- 电子围栏校验提示和备注 -->

        <div class="table-bottom">
            <div class="table-bottom-btn">
                <el-button type="primary" @click="handleBatchCancelArrival">批量取消运抵</el-button>
                <el-button type="primary" @click="handleBatchArrival">批量运抵</el-button>
            </div>
            <m-page
                :current-page="currentPage"
                :pageData="config.page"
                :total="pageTotal"
                @on-page-change="pageChange"
                @on-size-change="sizeChange"
                class="page-container"
            ></m-page>
        </div>
    </section>
</template>
<script>
import tableBox from '@/components/lots/tableBox/Index.vue';
import mPage from '@/components/otpPanel/mPage';
import DispatchHandleReason from '../dispatchHandleReason/Index';
import { formatTotalDataList } from './util';
import {
    quereyArrivalConfirm, updatehandlearrivedcust, updatecancelarrivedcust, quereyTasKNoArrivalConfirm,
    updatehandlearrivedcustByTransport, updatecancelarrivedcustByTransport, checkSiteAddressLclOperate,
    checkTransportLclOperate
}
    from '@/modules/transport/otp/api/performanceDispatchMgmtNew.js';
export default {
    name: 'dispatchLookOverTable',
    components: { tableBox, mPage, DispatchHandleReason },
    props: {
        config: Object,
        activeName: {
            type: String,
            default () {
                return '';
            }
        },
        dispatchNo: {
            type: String,
            default () {
                return '';
            }
        },
        dictData: {

        }
    },
    data () {
        return {
            loading: false,
            selected: [], // 选中数据
            tableData: [], // 列表数据
            page: {
                pageSize: 10,
                pageNo: 1
            },
            pageTotal: 0,
            currentPage: 1,
            func: quereyArrivalConfirm,
            isShowHandleReasonDialog: false, // 是否显示围栏校验提示
            handleType: 'shipTo', // 操作类型：站点运抵确认 | 运输单运抵确认
            componentsData: null,
            validateFn: {
                'shipTo': checkSiteAddressLclOperate, // 站点维度到车或抵达人工操作校验接口
                'shipToByTransport': checkTransportLclOperate // 运输单抵达人工操作校验接口
            },
            needTooltipData: []
        };
    },
    methods: {
        /**
             * @description 操作列事件处理
             * @event {事件类型} shipTo 运抵确认
             * @row   {Object} 行数据
            */
        actionClick (event, row, rIndex) {
            /* eslint-disable indent */
            switch (event) {
                case 'shipTo':
                    this.updatehandlearrivedcust(false, row);
                    break;
                case 'cancelShipTo':
                    this.handleUpdateCancelArrivedcust(row);
                    break;
                case 'shipToByTransport':
                    this.handlearrivedcustByTransport(false, row);
                    break;
                case 'cancelShipToByTransport':
                    this.cancelArrivedcustByTransport(row);
                    break;
                default:
                    break;
            }
        },
        // 选中数据
        onSelectionChange (data) {
            this.selected = data;
        },
        // 页数改变
        sizeChange (data) {
            this.page.pageSize = data;
            this.getList();
        },
        // 切分页
        pageChange (data) {
            this.page.pageNo = data;
            this.getList();
        },
        /**
         * @getList 使用发车单号查询列表明细
         * @param {Object} searchParams 查询条件
         * @dispatchNo 发车单号：
         */
        async getList () {
            const searchParams = {
                ...this.page,
                param: {
                    dispatchNo: this.dispatchNo
                }
            };
            this.func(searchParams).then(res => {
                if (res && +res.code === 0) {
                    this.tableData = formatTotalDataList(res.data.list || [], this.dictData);
                    this.pageTotal = res.data.totalCount;
                }
            });
        },
        // 参数为空处理
        getSearchData (data) {
            const _searchData = {
                ...this.page,
                ...data,
                pageNo: 1
            };
            for (const key in _searchData) {
                if (_searchData[key] === '') delete _searchData[key];
            }
            return _searchData;
        },
        // 刷新
        refresh () {
            this.getList();
        },
        closeFenceDialog () {
            this.isShowHandleReasonDialog = false;
            this.getList();
        },
        // 围栏校验备注回调函数
        handleSuccess ({ isFenceRemarked, data }) {
            switch (this.handleType) {
                case 'shipTo':
                    this.updatehandlearrivedcust(isFenceRemarked, data);
                    break;
                case 'shipToByTransport':
                    this.handlearrivedcustByTransport(isFenceRemarked, data);
                    break;
                default:
                break;
            }
        },
        // 电子围栏校验，接口返回true则需要备注人工操作原因
        validateFence (handleType, data) {
            let params = {};
            if (handleType === 'shipTo') {
                const siteAddressList = Array.isArray(data) ? data.map(v => v.siteAddress) : [data.siteAddress];
                params = { dispatchNo: this.dispatchNo, siteAddressList, type: 'arrival' };
            } else {
                const taskNos = Array.isArray(data) ? data.map(v => v.taskNo) : [data.taskNo];
                params = { dispatchNo: this.dispatchNo, taskNos };
            }
            const callApi = this.validateFn[handleType];
            return callApi(params).then(res => {
                if (res && +res.code === 0) {
                    if (Array.isArray(res.data) && res.data.length) {
                        this.needTooltipData = res.data;
                        return true;
                    } else {
                        return false;
                    }
                }
            }).catch(() => {
                return false;
            });
        },
        /**
         * description 站点运抵确认 运抵确认前进行电子围栏校验并增加提示 和 备注人工操作原因
         * @param {Boolean} isFenceRemarked (电子围栏校验)是否填写过人工操作原因
         */
        async updatehandlearrivedcust (isFenceRemarked = false, data) {
            if (!isFenceRemarked) {
                // 校验是否需要提示和备注原因
                this.handleType = 'shipTo';
                const isNeedTooltip = await this.validateFence(this.handleType, data);
                if (isNeedTooltip) {
                    this.isShowHandleReasonDialog = true;
                    this.componentsData = data;
                    return;
                }
            }
            // 继续运抵操作
            this.loading = true;
            const receiverDetailAddrList = Array.isArray(data) ? data.map(v => v.siteAddress) : [data.siteAddress];
            updatehandlearrivedcust({ dispatchNo: this.dispatchNo, receiverDetailAddrList })
            .then(res => {
                if (res && +res.code === 0) {
                    this.handleTips(res.data);
                }
            })
            .finally(() => {
                this.loading = false;
            });
        },
        /**
         * @description 站点维度 取消抵达
        */
        handleUpdateCancelArrivedcust (data) {
            this.loading = true;
            const receiverDetailAddrList = Array.isArray(data) ? data.map(v => v.siteAddress) : [data.siteAddress];
            updatecancelarrivedcust({ dispatchNo: this.dispatchNo, receiverDetailAddrList })
            .then(res => {
                if (res && +res.code === 0) {
                    this.handleTips(res.data);
                }
            })
            .catch(() => {})
            .finally(() => {
                this.loading = false;
            });
        },
        /**
         * description 运输单运抵确认 运抵确认前进行电子围栏校验并增加提示 和 备注人工操作原因
         * @param {Boolean} isFenceRemarked (电子围栏校验)是否填写过人工操作原因
         */
        async handlearrivedcustByTransport (isFenceRemarked = false, data) {
            if (!isFenceRemarked) {
                // 校验是否需要提示和备注原因
                this.handleType = 'shipToByTransport';
                const isNeedTooltip = await this.validateFence(this.handleType, data);
                if (isNeedTooltip) {
                    this.isShowHandleReasonDialog = true;
                    this.componentsData = data;
                    return;
                }
            }
            // 继续运抵操作
            this.loading = true;
            const receiverDetailAddrList = Array.isArray(data) ? data.map(v => v.siteAddress) : [data.siteAddress];
            const taskNos = Array.isArray(data) ? data.map(v => v.taskNo) : [data.taskNo];
            updatehandlearrivedcustByTransport({ dispatchNo: this.dispatchNo, receiverDetailAddrList, taskNos })
            .then(res => {
                if (res && +res.code === 0) {
                    this.handleTips(res.data);
                }
            })
            .finally(() => {
                this.loading = false;
            });
        },
        // 运输单取消运抵
        cancelArrivedcustByTransport (data) {
            this.loading = true;
            const receiverDetailAddrList = Array.isArray(data) ? data.map(v => v.siteAddress) : [data.siteAddress];
            const taskNos = Array.isArray(data) ? data.map(v => v.taskNo) : [data.taskNo];
            updatecancelarrivedcustByTransport({ dispatchNo: this.dispatchNo, receiverDetailAddrList, taskNos })
            .then(res => {
                if (res && +res.code === 0) {
                    this.handleTips(res.data);
                }
            })
            .catch(() => {})
            .finally(() => {
                this.loading = false;
            });
        },
        // 接口调用成功回调函数
        handleTips (data) {
            if (Array.isArray(data) && data.length) {
                const message = data.join('<br/>');
                this.$message({
                    type: 'warning',
                    message: message,
                    dangerouslyUseHTMLString: true
                });
                this.getList();
            } else {
                this.$message.success('操作成功');
                this.getList();
            }
        },
        // 批量取消运抵
        handleBatchCancelArrival () {
            if (!this.selected.length) return this.$message.warning('至少选择一条数据');
            if (this.activeName === 'siteDetails') {
                this.handleUpdateCancelArrivedcust(this.selected);
            } else {
                this.cancelArrivedcustByTransport(this.selected);
            }
        },
        // 批量运抵
        handleBatchArrival () {
            if (!this.selected.length) return this.$message.warning('至少选择一条数据');
            if (this.activeName === 'siteDetails') {
                this.updatehandlearrivedcust(false, this.selected);
            } else {
                this.handlearrivedcustByTransport(false, this.selected);
            }
        }
    },
    mounted () {
    },
    watch: {
        // 监听tab变化
        activeName: {
            handler (val) {
                if (val === 'siteDetails') {
                    this.func = quereyArrivalConfirm;
                } else {
                    this.func = quereyTasKNoArrivalConfirm;
                }
                this.getList();
            },
            immediate: true // 立即执行
        }
    }

};
</script>

<style  lang="less" scoped>
.dispatchOrder-table {
    .mPane3-back-up .el-table {
        min-height: inherit;
    }
}
.dispatchOrder-table .model-table-search {
    display: none;
}
.dispatchOrder-table {
    margin-bottom: 0px;
    .table-bottom {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 14px;
    }
}
</style>
